import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const Banner = () => {
  const [banners, setBanners] = useState([]);
  const isDesktop = window.innerWidth > 992;

  // ✅ Fetch banners from API
  useEffect(() => {
    // fetch("https://clariss-backend-one.vercel.app/sliders")
    fetch("https://clariss-backend-one.vercel.app/sliders")
      .then((res) => res.json())
      .then((data) => {
        setBanners(data);
      })
      .catch((err) => console.error(err));
  }, []);

  // ✅ Current time (BD)
  const now = dayjs().tz("Asia/Dhaka");

  // ✅ Filter + Sort banners
  const activeBanners = banners
    .filter((banner) => {
      if (banner.status !== "published") return false;

      const endTime = dayjs.tz(banner.endTime, "Asia/Dhaka");
      return now.isBefore(endTime);
    })
    .sort((a, b) => a.order - b.order);

  return (
    <section aria-label="Clariss Dynamic Banner Slider">
      <Swiper
        spaceBetween={30}
        effect="fade"
        navigation={window.innerWidth >= 992}
        autoplay={{
          delay: 10000,
          disableOnInteraction: false,
        }}
        pagination={window.innerWidth < 700 ? false : { dynamicBullets: true }}
        modules={[Autoplay, EffectFade, Navigation, Pagination]}
        className="mySwiper"
      >
        {activeBanners.map((banner) => (
          <SwiperSlide key={banner._id}>
            <Link to={banner.link}>
              <img
                src={isDesktop ? banner.desktopImg : banner.mobileImg}
                alt={banner.name}
                className="w-full h-auto"
                loading="lazy"
                width={isDesktop ? 1920 : 400}
                height={isDesktop ? 500 : 200}
              />
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Banner;
